"use client";

import { motion } from "motion/react";
import { type ReactNode } from "react";

import { cn } from "../../../../utils";

export interface NumericInputMessageProps {
  error?: ReactNode;
  warning?: ReactNode;
  extraInfo?: ReactNode;
}

export const NumericInputMessage: React.FC<NumericInputMessageProps> = ({
  error,
  warning,
  extraInfo,
}) => {
  const message = error || warning || extraInfo;
  const hasMessage = Boolean(message);

  return (
    <motion.div
      transition={{ duration: 0.2 }}
      exit={hasMessage ? "end" : "start"}
      animate={hasMessage ? "end" : "start"}
      initial={hasMessage ? "end" : "start"}
      variants={{
        start: { height: 0, opacity: 0 },
        end: { height: 8, opacity: 1 },
      }}
    >
      {hasMessage && (
        <div
          className={cn("ui:pl-3 ui:text-[11px]", {
            "ui:text-error": error,
            "ui:text-warning": !error && warning,
          })}
        >
          {message}
        </div>
      )}
    </motion.div>
  );
};
